// extracted by mini-css-extract-plugin
export default {"files":"UploadComponent_files__rkK91","link":"UploadComponent_link__lGYNx"};